import { yup } from '@framework/validation/initYup.ts';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { uniqueWidgetCodeSchema } from '../../../validation/uniqueWidgetCodeSchema.ts';
import { WidgetType } from '../../../Widget.ts';
import { CommonContainerWidgetConfigSchema } from '../../containers/common/CommonContainerWidgetConfigSchema.ts';
import { type ISubsectionWidget } from './ISubsectionWidget.ts';
import { SubsectionRendering } from './SubsectionRendering.ts';

export const SubsectionWidgetConfigSchema: yup.ObjectSchema<ISubsectionWidget> =
  CommonContainerWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Subsection).required(),
    code: uniqueWidgetCodeSchema,
    label: RichTextAdvancedSchema.optional().label('Titolo'),
    placeholder: yup
      .string()
      .optional()
      .label('Testo Pulsante')
      .default('Apri sottosezione')
      .when('rendering', ([rendering]: SubsectionRendering[], schema) => {
        return rendering === SubsectionRendering.Drawer
          ? schema.required()
          : schema.strip();
      }),
    rendering: yup
      .string()
      .oneOfEnum(SubsectionRendering)
      .required()
      .default(SubsectionRendering.Drawer)
      .label('Visualizzazione'),
    viewInResume: yup
      .boolean()
      .notRequired()
      .default(false)
      .label('Visualizza in riepilogo'),
  })
    .required()
    .noUnknown();
